import type { SchemaField } from '@cli-types/core-engine/schema.js'
export function getHtmlOutputFields(fields: SchemaField[]): SchemaField[] {
  return fields.filter((field) => {
    return (field.type === 'richtext' || field.type === 'markdown') && field.output === 'html'
  })
}
